import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import CompareDemo from "@/components/CompareDemo";
import PartnerLogos from "@/components/PartnerLogos";
import VerticalCardsSection from "@/components/VerticalCardsSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ComplianceNote from "@/components/ComplianceNote";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import CookieConsent from "@/components/CookieConsent";
import AskFlexaura from "@/components/ai/AskFlexaura";
import TrustBadges from "@/components/TrustBadges";
import TrustSection from "@/components/TrustSection";
import { suggestFinancePlans } from "@/lib/finance-plans";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  const financeAmount = 50000;
  const financeOptions = suggestFinancePlans({
    vertical: "education",
    amountAED: financeAmount,
    context: { level: "primary", termCount: 3, enrolled: true }
  });

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        {/* 1. Hero */}
        <HeroSection />

        {/* 2. Trust badges */}
        <TrustBadges />

        {/* 3. How It Works */}
        <HowItWorksSection />

        {/* 4. Vertical Cards */}
        <VerticalCardsSection />

        {/* 5. Compare Plans */}
        <CompareDemo />

        {/* 6. Trust / Partner section */}
        <TrustSection />

        {/* Partner CTA link */}
        <section className="py-12 px-4 text-center">
          <p className="text-muted-foreground font-body mb-4">
            Want to offer flexible payments to your customers?
          </p>
          <Button variant="outline" onClick={() => navigate("/partners")}>
            Become a Partner
          </Button>
        </section>

        {/* 7. FAQ */}
        <FAQSection />

        {/* 8. CTA */}
        <CTASection />
      </main>
      <ComplianceNote />
      <Footer />
      <StickyMobileCTA />
      <CookieConsent />
      <AskFlexaura 
        context={{ vertical: "education", amountAED: financeAmount }}
        plans={financeOptions}
      />
    </div>
  );
};

export default Index;
